import { render, staticRenderFns } from "./module1.vue?vue&type=template&id=62726848&scoped=true"
import script from "./module1.vue?vue&type=script&lang=js"
export * from "./module1.vue?vue&type=script&lang=js"
import style0 from "./module1.vue?vue&type=style&index=0&id=62726848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62726848",
  null
  
)

export default component.exports